<div class="mapContainer">
    @if (selectedMarkerData && selectedMarkerData.length) {
        <div class="infoPanelContainer">
            <header>
                <lib-counter-badge [label]="'Companies'" [count]="companiesCounter || 0"></lib-counter-badge>
                <button
                    (click)="closePanel()"
                    [innerHTML]="closeIcon"
                    class="resetStyles closeButton"
                    aria-label="Close panel"
                ></button>
            </header>
            @for (item of selectedMarkerData; track item.id) {
                <ng-container class="itemContent">
                    <app-map-card [cardData]="item"></app-map-card>
                </ng-container>
            }
        </div>
    }

    <div id="map"></div>
</div>

<ng-container #popupContainer></ng-container>
